// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3K_KS","info":"Note_info__391iF","note":"Note_note__2aTpl","actions":"Note_actions__15xZ3"};